import * as PIXI from 'pixi.js'

export class DrawCanvas {
  constructor(_digit, _rectSize) {
    this.digit = _digit
    this.rectSize = _rectSize
  }

  drawLine(container) {
    const lines = new PIXI.Graphics();
    lines.lineStyle(1, 0x000000);
    for(let i = 0; i <= this.digit.x; i++) {
      lines.moveTo(i * this.rectSize, 0)
      lines.lineTo(i * this.rectSize, 500)
    }
    for(let i = 0; i <= this.digit.y; i++) {
      lines.moveTo(0, i * this.rectSize)
      lines.lineTo(500, i * this.rectSize)
    }
    return container.addChild(lines)
  }
}